import { ReactComponent as Home } from "./images/home.inline.svg";
import { ReactComponent as Profile } from "./images/profile.inline.svg";
import { ReactComponent as Schedule } from "./images/schedule.inline.svg";
import { ReactComponent as Search } from "./images/search.inline.svg";

const menu = [
  {
    name: "дом",
    root: "/",
    icon: Home,
  },
  {
    name: "исследуй",
    root: "/search",
    icon: Search,
  },
  {
    name: "расписание",
    root: "/schedule",
    icon: Schedule,
  },
  {
    name: "профиль",
    root: "/profile",
    icon: Profile,
  },
];

export default menu;
